import config from '../../config'
import { IAxiosSuccess } from '../interface'
import server from '../axiosInstance'
import { ContentType } from '../header'
import { filterDataEmpty } from '../utils'
import { DynamicDataSucType } from '../types/dynamic'

const { baseURL } = config

/**
 * 获取用户动态
 * @param uid 用户uid
 * @returns
 */
export const getDynamicData = (userId: string, contentId: string): Promise<IAxiosSuccess<DynamicDataSucType>> => {
  const params = Object.assign({}, {}, {
    userId,
    contentId
    // sign: '',
    // appId: 1004,
    // timestamp,
    // random
  })
  // params.sign = getSignedData(params, baseSecret)
  filterDataEmpty(params)
  return server.request<null, IAxiosSuccess<DynamicDataSucType>>({
    url: `${baseURL}/v1/social/web/contentDetail`,
    method: 'GET',
    headers: {
      'Content-Type': ContentType.JSON
    },
    needAuth: true,
    params
  })
}
